module.exports = __webpack_public_path__ + "static/media/Expo.c0f2999c.png";